import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Archive } from 'lucide-react';
import { useJobs } from '../hooks/useJobs';
import JobList from '../components/jobs/JobList';
import AddJobPopup from '../components/jobs/AddJobPopup';
import EditJobPopup from '../components/jobs/EditJobPopup';
import type { Job } from '../types/job';
import LoadingPage from '../components/ui/LoadingPage';

export default function Jobs() {
  const navigate = useNavigate();
  const { jobs, loading, error, refetch } = useJobs();
  const [showAddJob, setShowAddJob] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [editingJob, setEditingJob] = useState<Job | null>(null);

  const handleViewJob = (job: Job) => {
    navigate(`/jobs/${job.id}`);
  };

  const filteredJobs = jobs.filter(job => 
    showArchived ? job.status === 'archived' : job.status !== 'archived'
  );

  if (loading) {
    return <LoadingPage message="Loading opportunities..." />;
  }

  if (error) {
    return (
      <div className="min-h-[400px] flex items-center justify-center">
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <h1 className="text-2xl font-bold">Opportunities</h1>
        <div className="flex-1 flex justify-end items-center gap-4">
          <button
            onClick={() => setShowArchived(!showArchived)}
            className={`btn ${showArchived ? 'btn-primary' : 'btn-secondary'} flex items-center gap-2`}
          >
            <Archive className="w-5 h-5" />
            {showArchived ? 'Show Active' : 'Show Archived'}
          </button>
          <button
            onClick={() => setShowAddJob(true)}
            className="btn btn-primary flex items-center gap-2"
          >
            <Plus className="w-5 h-5" />
            Add Opportunity
          </button>
        </div>
      </div>

      <JobList
        jobs={filteredJobs}
        onViewJob={handleViewJob}
        onEditJob={setEditingJob}
        onRefresh={refetch}
      />

      {showAddJob && (
        <AddJobPopup
          onClose={() => setShowAddJob(false)}
          onSuccess={() => {
            refetch();
            setShowAddJob(false);
          }}
        />
      )}

      {editingJob && (
        <EditJobPopup
          job={editingJob}
          onClose={() => setEditingJob(null)}
          onSuccess={() => {
            refetch();
            setEditingJob(null);
          }}
        />
      )}
    </div>
  );
}